<template>
    <div class="main_user  p-3">
        <div class="categ_info p-3 pt-0" v-if="obj_to_null(this.user)">
            <div class="row">
                <div class="col-lg-6 col-xs-12 pl-5 pr-5">
                    <div class="info">
                        <div class="mb-8 flex items-center">
                            <span class="text-warning">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="vue-feather text-theme dark-text-theme mr-3 feather feather-list"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
                            </span>
                            <b class="text-md font-bold fs-xl">
                                {{__t('USER_LOCALES_INFO')}}
                            </b>
                        </div>
                    </div>

                    <div class="user_settings mt-5">
                        <div class="form-group mt-2">
                            <label class="form-label" for="wlocal">
                                {{__t("WOLT_LOCALES")}}*
                            </label>

                            <div class="" v-if="locales.length > 0">
                                <v-select v-model="active_local"
                                          class="imc_reasons"
                                          label="name"
                                          :options="this.locales"
                                          :clearable="false"
                                          :filterable="false"
                                >
                                    <template slot="no-options">
                                        {{__t("CHOICE_LOCALE")}}
                                    </template>

                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            <div>
                                                {{ option.name }}
                                            </div>
                                            <div>
                                                <small>
                                                    {{option.code}}
                                                </small>
                                            </div>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>

                        <div class="form-group mt-2">
                            <label class="form-label" for="wcurrency">
                                {{__t("WOLT_CURRENCIES")}}*
                            </label>

                            <div class="" v-if="currencies.length > 0">
                                <v-select v-model="active_currency"
                                          class="imc_reasons"
                                          label="name"
                                          key="w_curency"
                                          :options="this.currencies"
                                          :filterable="false"
                                          :clearable="false"
                                >
                                    <template slot="no-options">
                                        {{__t("CHOICE_CURENCY")}}
                                    </template>

                                </v-select>
                            </div>
                        </div>
                    </div>



                     <div class="form-group mt-5">
                        <label class="form-label" for="w_timezones">
                            {{__t("TIMEZONE_LIST")}}*
                        </label>

                        <div class="" v-if="timezones.length > 0">
                            <v-select v-model="active_timezone"
                                      class="imc_reasons"
                                      label="name"
                                      value="value"
                                      :reduce="item => item.value"
                                      key="w_timezones"
                                      :options="this.timezones"
                                      :filterable="true"
                                      :clearable="false"
                            >
                                <template slot="no-options">
                                    {{__t("CHOICE_CURENCY")}}
                                </template>

                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        <div>
                                            {{ option.name }}
                                        </div>
                                        <div>
                                            <small>
                                                {{ option.value }}
                                            </small>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </div>
                     </div>

                    <div class="prov_out_settings mt-5">
                        <div class="panel-tag">
                            {{ __t('DECIMAL_SETTINGS') }}
                        </div>

                        <div class="form-group" >
                            <div class="form-group mt-2" >
                                <label class="form-label" for="decimal_count">
                                    {{__t('DECIMAL_COUNT')}}
                                </label>

                                <div class="input-group flex-nowrap">
                                    <b-form-radio-group
                                        v-model="cur_decimal"
                                        button-variant="outline-primary"
                                        :options="decimal_props"
                                        id="decimal_global"
                                        buttons
                                    ></b-form-radio-group>
                                </div>
                            </div>
                        </div>

                        <div class="form-group" >
                            <label class="form-label" for="order_cur_decimal">
                                {{__t('ORDER_DECIMAL_COUNT')}}
                            </label>

                            <div class="input-group flex-nowrap">
                                <b-form-radio-group
                                    v-model="order_cur_decimal"
                                    button-variant="outline-primary"
                                    :options="decimal_props"
                                    id="order_cur_decimal"
                                    buttons
                                ></b-form-radio-group>
                            </div>

                        </div>
                    </div>




                </div>

            </div>

            <div class="next_step text-right">
                <button class="btn   btn-lg  mt-3 mb-3 imc_succ " :class="{
                                                      'btn-success' : can_save,
                                                      'btn-outline-warning' : !can_save
                                                }" v-on:click.prevent="save">
                    <span class="fal fal fa-check mr-1" v-if="can_save"></span>
                    <span class="fal fa-exclamation-triangle mr-1" v-if="!can_save"></span>
                    {{__t('SAVE')}}
                </button>

            </div>

        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: "user_locales",
    components : {
        vSelect
    },
    props: {
        user: {
            type: Object
        }
    },
    data() {
        return {
            locales : [],
            currencies : [],
            inp_fields : [],
            timezones : [],
            decimal_props : [
                { text: this.__t('NO_ROUND'), value: -1 },
                { text: this.__t('3.25 -> 3'), value: 0 },
                { text: this.__t('3.55 -> 3.6'), value: 1 },
                { text: this.__t('3.55 -> 3.55'), value: 2 },
            ]
        }
    },
    mounted() {
        if(this.user.hasOwnProperty("fields")){
            return this.user.fields.map(itm => {
                this.inp_fields.push(itm);
            })
        }
    },

    created() {
        this.load_params();
    },

    methods: {
        async save() {
            if(this.can_save) {
                _core.showloading();

                await api.put('/internal/user/save',{
                    'data' : this.inp_fields,
                    'cur_decimal' : this.cur_decimal,
                    'order_decimal_count' : this.order_cur_decimal,
                    'locale_id' : this.active_locale_id,
                    "time_zone" : this.active_timezone,
                    'currency_id' : this.active_currency_id,
                    'type' : "locale"
                }).then(({data}) => {
                    _core.hideloading();

                    if (data.status === "operation_success") {
                        EventBus.$emit("reload_full_user");
                    }
                }).catch(({response}) => {
                    _core.hideloading();
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            }
        },


        async load_params() {
            this.locales = [];
            await api.get('/api/v2/locales',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.locales = data.data;
                }
                return data;
            }).then(({data}) => {
                this.load_timezones();
                return this.load_currencies();
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },


        async load_timezones() {
            this.timezones = [];
            await api.get('/api/v2/timezones',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.timezones = data.data;
                }

            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async load_currencies() {
            await api.get('/api/v2/currencies',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.currencies = data.data;
                }

            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },
    computed : {


        can_save () {
            return true
        },

        active_locale_id () {
            try {
                return parseInt(this.active_local.locale_id);
            }
            catch (E) {

            }
            return 3;
        },
        active_currency_id () {
            try {
                return parseInt(this.active_currency.id);
            }
            catch (e) {

            }
            return 4;
        },

        cur_decimal : {
            get :function () {
                return this.user.client.currency_decimal_count;
            },
            set: function (val){
                this.user.client.currency_decimal_count = val;
            }
        },
        order_cur_decimal : {
            get :function () {
                return this.user.client.order_decimal_count;
            },
            set: function (val){
                this.user.client.order_decimal_count = val;
            }
        },

        active_local : {
            get :function () {
                let active = null;
                if(this.locales.length > 0) {
                    if(this.user.client.hasOwnProperty("locale_id")) {
                        this.locales.map(item => {
                            if(parseInt(item.locale_id) === parseInt(this.user.client.locale_id)) {
                                active = item;
                            }
                        })
                    }
                }

                return active;
            },

            set: function (val){
                if(val != null) {
                    if (this.user.client.hasOwnProperty("locale_id")) {
                        this.user.client.locale_id = val.locale_id;
                    }
                }
                else {
                    this.user.client.locale_id = 0;
                }
            },
        },

        active_timezone : {
            get :function () {
                if (this.user.client.hasOwnProperty("timezone")) {
                    return this.user.client.timezone;
                }

                return '';
            },

            set: function (val){
                if(val != null) {
                    if (this.user.client.hasOwnProperty("timezone")) {
                        this.user.client.timezone = val;
                    }
                }
                else {
                    this.user.client.timezone = "";
                }
            }
        },

        active_currency : {
            get :function () {
                let active = null;
                if(this.currencies.length > 0) {
                    if(this.user.client.hasOwnProperty("currency_id")) {
                        this.currencies.map(item => {
                            if(parseInt(item.id) === parseInt(this.user.client.currency_id)) {
                                active = item;
                            }
                        })
                    }
                }

                return active;
            },

            set: function (val){
                if(val != null) {
                    if (this.user.client.hasOwnProperty("currency_id")) {
                        this.user.client.currency_id = val.id;
                    }
                }
                else {
                    this.user.client.currency_id = 0;
                }
            },
        },

    }

}
</script>

<style scoped>

</style>
